
import axiosServices from '@/services/axiosServices.js'
var fJsonPath = require('jsonpath');
export default {
  data() {
    return {
      tituloGrids: '',
      oPermisos: {
        priv_access: "1",
        priv_insert: "0",
        priv_delete: "0",
        priv_update: "0"
      }
    }
  },

  methods: {
    onValidarTokenSinLogin () {
      if(this.$route.query.t != undefined && this.$route.query.ip != undefined){
        //console.log("query","ingreso validacion exitosa grid")
        let sToken = this.$route.query.t
        let sIP = this.$route.query.ip
        this.$store.dispatch('setLogin', true);
        this.$store.dispatch('saveToken', sToken);
        sessionStorage.ip = sIP
        this.$store.dispatch('save_sIP', sIP);
        //console.log("entro")
      }
    },
    async getTitulo (sTableName, bSubdominioTemporal = false) {
      let sParams = `sTable=${sTableName}&nPerfil=${this.$store.state.idPerfil}`
      if(bSubdominioTemporal){
        sParams = sParams + `&subdominiot=${this.$store.state.sSubdominioTemporal}`
      }
      const aTitulo = await axiosServices.getConfiguration('pGrids_titulo', true, sParams )
      //console.log(aTitulo)
      if(typeof aTitulo.aData[0].priv_access !== 'undefined') this.oPermisos.priv_access = aTitulo.aData[0].priv_access
      if(typeof aTitulo.aData[0].priv_insert !== 'undefined') this.oPermisos.priv_insert = aTitulo.aData[0].priv_insert
      if(typeof aTitulo.aData[0].priv_delete !== 'undefined') this.oPermisos.priv_delete = aTitulo.aData[0].priv_delete
      if(typeof aTitulo.aData[0].priv_update !== 'undefined') this.oPermisos.priv_update = aTitulo.aData[0].priv_update
      return await aTitulo.aData[0].tituloGrid
    },
    onExtraerNombreCampoGridAnidada(oItem){
      return Object.keys(oItem)[0];
    },
    onExtraerIdSelectGridAnidada(oItem, sNombreTabla = ''){
      if (sNombreTabla != ''){
        if (oItem.hasOwnProperty(`id${sNombreTabla}`)){
          return isNaN(parseInt(oItem[`id${sNombreTabla}`]))? 0 : parseInt(oItem[`id${sNombreTabla}`])
        }else{
          return isNaN(parseInt(oItem[Object.keys(oItem)[0]]))? 0 : parseInt(oItem[Object.keys(oItem)[0]])
        }
      }else{
        if (oItem.hasOwnProperty(`id${this.tabla}`)){
          return isNaN(parseInt(oItem[`id${this.tabla}`]))? 0 : parseInt(oItem[`id${this.tabla}`])
        }else{
          return isNaN(parseInt(oItem[Object.keys(oItem)[0]]))? 0 : parseInt(oItem[Object.keys(oItem)[0]])
        }
      }
    },
    onFormatearAnexos(aAnexos) {
      let aGaleria = [];
      // recorro los Anexos para sacar todos los nombres de las anexos que tenga y dejarlos como [ {Foto : "NombreArchico"}]
      aAnexos.forEach(oItem => {
        // valido que no sea un file lizt con mas de un elemento 
        if(oItem instanceof Array){
          // Lo recorro de nuevo
          Object.keys(oItem).forEach( oSubItem => {
            aGaleria.push({ Foto : oItem[oSubItem].name , TipoAnexo: (oItem[oSubItem].type.includes('image')) ?'1' : '2' })
          })
        } else {
          if(oItem){
            aGaleria.push({ Foto : oItem.name, TipoAnexo: (oItem.type.includes('image')) ?'1' : '2'})
          }
        }
      })
  
      return aGaleria
  
    },
    async onSubirAnexos(aArchivos){
      aArchivos.forEach(Anexo => {
        // valido que no sea null o undefined
          if(Anexo){
            this.onSubirAnexo(Anexo)
          }
      })
    },
    // Esta funcion sube un archivo individual al servidor y devuelve la respuesta de la peticion de manera asincrona
    async onSubirAnexo(oArchivo){
      const nTipoAnexo = (oArchivo.type.includes('image')) ? 1 : 2
      const formData = new FormData()
      formData.append('file', oArchivo)
      const oRespuesta = await axiosServices.postFile('/subirarchivo', formData, true, nTipoAnexo)
      return oRespuesta
    },
    onFiltrarJson(aData,sQuery,aDataFiltrar = [], sRegex = ''){
      if(aDataFiltrar.length == 0){
        return fJsonPath.query(aData,sQuery)
      }else{
        aDataFiltrar = [...new Set(aDataFiltrar)]; 
        let aDataResultado = []
        aDataFiltrar.forEach(sItem =>{
          const aResultado = fJsonPath.query(aData,sQuery.replace(sRegex, sItem))
          aDataResultado = aDataResultado.concat(aResultado)
        })
        return aDataResultado
      }
    },
    onFiltrarJsonLibre(aData,sQuery){
      return fJsonPath.query(aData,sQuery)
  
    },
  },
  computed: {
    onValidarBotonDeshabilitado(){
      return this.$bCargando
    }
  }
}